import { catchError, filter, map, mergeMap } from "rxjs/operators";
import { of } from "rxjs";
import { StateObservable } from "redux-observable";

import { addMessage } from "../../../../../../../../../redux/actions/messagesActions";
import { Effect } from "../../../../../../../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../../../../../../../redux/types/effect-actions-observable.type";
import { isActionType } from "../../../../../../../../../redux/action.functions";
import { RootState } from "../../../../../../../../../redux/store";

import { FlyerDetailPageActions } from "../../../store/flyer-detail-page.actions";
import * as flyerDetailPageActions from "../../../store/flyer-detail-page.actions";
import * as flyerDetailPagePositionService from "../../../services/flyer-detail-page-position.service";
import * as flyerDetailPageStore from "../../../store/flyer-detail-page.store";

import * as actions from "./flyer-detail-page-form-position.actions";
import * as store from "./flyer-detail-page-form-position.store";
import { FlyerDetailPageFormPositionActions } from "./flyer-detail-page-form-position.actions";
import { FlyerDetailPageFormPositionCategoriesEffects } from "./flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.effects";

export const fetchPosition: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(FlyerDetailPageFormPositionActions.FetchPosition)),
    map((action) => action.payload),
    mergeMap((positionId) =>
      flyerDetailPagePositionService.fetchPosition(positionId).pipe(
        map((position) => actions.fetchPositionSuccess(position)),
        catchError((error) => of(actions.fetchPositionFailure(error)))
      )
    )
  );

export const savePosition: Effect = (
  action$: EffectActionsObservable,
  state$: StateObservable<RootState>
) =>
  action$.pipe(
    filter(isActionType(FlyerDetailPageFormPositionActions.SavePosition)),
    map((action) => ({
      changes: action.payload,
      position: store.getPosition(state$.value),
    })),
    mergeMap(({ changes, position }) =>
      flyerDetailPagePositionService.savePosition(position!.id, changes).pipe(
        map((result) => actions.savePositionSuccess(result)),
        catchError((error) => of(actions.savePositionFailure(error)))
      )
    )
  );

export const savePositionSuccess: Effect = (
  action$: EffectActionsObservable,
  state$: StateObservable<RootState>
) =>
  action$.pipe(
    filter(isActionType(FlyerDetailPageFormPositionActions.SavePositionSuccess)),
    map(() => flyerDetailPageStore.getPageId(state$.value)),
    mergeMap((pageId) =>
      of(
        addMessage({ text: "Position saved successfully.", severity: "success" }),
        flyerDetailPageActions.fetchPagePreview(pageId!)
      )
    )
  );

export const savePositionFailure: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(FlyerDetailPageFormPositionActions.SavePositionFailure)),
    map((action) => action.payload),
    map((error) => addMessage({ text: error.errorMessage, severity: "error" }))
  );

const reset: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(FlyerDetailPageActions.Reset)),
    map(() => actions.reset())
  );

export const FlyerDetailPageFormPositionEffects = [
  fetchPosition,
  savePosition,
  savePositionSuccess,
  savePositionFailure,
  reset,

  ...FlyerDetailPageFormPositionCategoriesEffects,
];
